import { makeStyles } from 'tss-react/mui'

const Roboto = ['Roboto', 'sans-serif'].join(',')

export const getOrMakeWhatsAppStyles = makeStyles()(() => ({
    view: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative'
    },
    syoWhatsApp: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    },
    loadingContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
    },
    selectContactContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
    },
    selectContactCenter: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    selectContactIconCircle: {
        width: 40,
        height: 40
    },
    selectContactIcon: {
        fontSize: 24
    },
    selectContactText: {
        margin: 0,
        paddingTop: 16,
        fontFamily: Roboto,
        fontSize: '20px',
        color: '#00000099',
        opacity: 60,
        fontWeight: 400
    },
    loadingText: {
        marginTop: 15
    },
    errorContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgb(254, 242, 241)',
        height: '100%'
    },
    errorText: {
        color: 'rgb(99, 51, 48)',
        marginTop: 12
    }
}))
